import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme } from "@mui/material/styles";
import Naviagtion from "./navigation.tsx";
import { Container } from "@mui/material";
import { useLocation } from "react-router-dom";

const FULL_WIDTH_PATHS = ["/fleet/eventspammers"];

const theme = createTheme({
  palette: {
    mode: "dark",
  },
});

function Layout(props) {
  const location = useLocation();
  const fullWidth = FULL_WIDTH_PATHS.includes(location.pathname);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ display: "flex" }}>
        <Naviagtion />
        <main
          style={{
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Container maxWidth={fullWidth ? false : "xl"} className="container height: 100%;">
            {props.children}
          </Container>
        </main>
      </div>
    </ThemeProvider>
  );
}

export default Layout;
